import { createFileRoute } from "@tanstack/react-router";
import AdminLinkDirectory from "@/pages/AdminLinkDirectory";
export const Route = createFileRoute("/admin-links")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Admin Access | Neuro Wellness TMS Centers of America",
        },
        {
          name: "description",
          content:
            "Restricted admin access page in Coral Springs, FL Free consultation available Contact us to learn more We can help We accept most insurance plans.",
        },
        {
          property: "og:title",
          content: "Admin Access | Neuro Wellness TMS Centers of America",
        },
        {
          property: "og:description",
          content:
            "Restricted admin access page in Coral Springs, FL Free consultation available Contact us to learn more We can help We accept most insurance plans.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/admin-links",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/admin-links",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AdminLinkDirectory />;
}
